import { Icon } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { getNumberOfInstructors } from '@mc/instructors'
import { paths } from '@mc/paths'
import { TrackingContainer } from '@mc/visibility'
import { Locations, PageSource } from '@mc/track-event'

import CTA from 'components/CTA'
import { trackValuePropViewed } from 'components/ValueProps'

import styles from './Subscription.module.scss'

const DEFAULT_PAGE_SOURCE = 'Course Marketing'

export const Subscription = ({
  pageSource = DEFAULT_PAGE_SOURCE,
  eventProps = {},
}: {
  pageSource?: string
  eventProps?: Record<string, string | number | undefined>
}) => {
  const { t } = useTranslation('@mc/next')

  const list = [
    {
      icon: 'lessons',
      text: t('subscription.info.allClassesWithSeries', {
        instructors: getNumberOfInstructors(),
      }),
    },
    {
      icon: 'unmuted',
      text: t('subscription.info.audio'),
    },
    {
      icon: 'download',
      text: t('subscription.info.offline'),
    },
    {
      icon: 'list',
      text: t('subscription.info.workbooks'),
    },
    {
      icon: 'lessons',
      text: t('subscription.info.devices'),
    },
    {
      icon: 'star',
      text: t('subscription.info.newClasses'),
    },
  ]

  const location =
    pageSource === PageSource.HOME
      ? Locations.WHAT_YOU_WILL_GET
      : Locations.WHATS_INCLUDED

  const baseTrackProps = {
    location,
    category: 'whats-included',
    page_source: pageSource,
  }

  return (
    <TrackingContainer onFirstVisible={trackValuePropViewed}>
      <section className='container mc-my-10' data-testid='subscription'>
        <div className='row align-items-center justify-content-center justify-content-lg-start'>
          <div className='col-12 col-lg-6 mc-text--center mc-text-lg--left'>
            <h2 className='mc-text-h2'>{t('subscription.title')}</h2>
            <div className='mc-mt-6'>
              <div className='d-flex justify-content-center justify-content-lg-start'>
                <div className='col-6 col-sm-4'>
                  <CTA
                    fullWidth
                    trackProps={{
                      ...baseTrackProps,
                      ...eventProps,
                    }}
                  />
                </div>
                <div className='col-6 col-sm-4'>
                  <CTA
                    fullWidth
                    href={paths.gift}
                    kind='tertiary'
                    trackProps={{
                      type: 'gift',
                      ...baseTrackProps,
                      ...eventProps,
                    }}
                  >
                    {t('subscription.gift')}
                  </CTA>
                </div>
              </div>
            </div>
          </div>

          <div className='col-12 col-lg-5 offset-lg-1 d-flex justify-content-center'>
            <ul className='mc-overflow--hidden'>
              {list.map(({ icon, text }) => (
                <li className={`mc-my-3 ${styles.item}`} key={text}>
                  <Icon
                    className='mc-icon--3 mc-opacity--hinted mc-mr-3'
                    kind={icon}
                  />
                  {text}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </TrackingContainer>
  )
}
